/**
 * @file pages/BookTour.jsx
 * @description Book Tour page that renders the BookingForm component
 * for a specific tour identified by URL parameter.
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import BookingForm from '../Components/Booking/BookingForm';

const BookTour = () => {
  const { id } = useParams();
  
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <BookingForm tourId={id} />
      </div>
    </div>
  );
};

export default BookTour;
